import React, { useState } from 'react';
import { Form, Input, Button, Typography, message } from 'antd';
import { MobileOutlined, LockOutlined, EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import { resetPassword } from '../api/auth';
import '../styles/Login.css';

const { Title } = Typography;

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    try {
      setLoading(true);
      await resetPassword(values.phone);
      message.success('密码重置申请已发送，请查收验证码！');
      // 这里可以跳转到输入验证码的页面或其他流程
      // navigate('/verify-code');
    } catch (error) {
      console.error('密码重置失败:', error);
      message.error('密码重置失败: ' + (error.response?.data?.message || '服务器错误'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-form-container">
        <Title level={2} className="login-title">
          设置密码
        </Title>
        <Form
          name="reset_password_form"
          className="login-form"
          onFinish={onFinish}
          size="large"
        >
          <div className="input-label">请输入手机号</div>
          <Form.Item
            name="phone"
            rules={[
              { required: true, message: '请输入手机号!' },
              { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号码!' }
            ]}
          >
            <Input
              prefix={<MobileOutlined className="input-icon" />}
              placeholder="请输入手机号"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              className="login-button"
            >
              获取验证码
            </Button>
          </Form.Item>
          
          <div className="reset-password">
            <Link to="/login">返回登录</Link>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default ResetPassword; 